import { supportServiceConnectClient } from "api";

import {
  DeleteInstallationRequest,
  DeleteInstallationResponse,
  ListInstallationsRequest,
  ListInstallationsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/integrations/admin/v1/integrations_admin_pb";

import { RequestMetadata } from "api/types";

type ListIntegrationsParams = {
  organisationID: string;
};
export const listIntegrations = async (
  { organisationID }: ListIntegrationsParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListInstallationsResponse> => {
  const req = new ListInstallationsRequest({ orgId: organisationID });
  return supportServiceConnectClient.listInstallations(req, { headers });
};

type DeleteIntegrationsParams = {
  integrationID: string;
  organisationID: string;
};

export const deleteIntegrations = async (
  { organisationID, integrationID }: DeleteIntegrationsParams,
  headers: Record<RequestMetadata, string>,
): Promise<DeleteInstallationResponse> => {
  const req = new DeleteInstallationRequest({
    id: integrationID,
    orgId: organisationID,
  });
  return supportServiceConnectClient.deleteInstallation(req, { headers });
};
